import { formatScore as formatScore$1 } from "@hlt/domain";
// src/format/index.ts
/** Locale-aware date/time display in an explicit timezone (workspace or audit). */
function formatDateTime(iso, locale, timeZone, style = "medium") {
	return new Intl.DateTimeFormat(locale, {
		dateStyle: style,
		timeStyle: "short",
		timeZone
	}).format(new Date(iso));
}
function formatDate(iso, locale, timeZone) {
	return new Intl.DateTimeFormat(locale, {
		dateStyle: "medium",
		timeZone
	}).format(new Date(iso));
}
function formatRelative(iso, locale, now = Date.now()) {
	const diff = new Date(iso).getTime() - now;
	const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
	const minutes = Math.round(diff / 6e4);
	if (Math.abs(minutes) < 60) return rtf.format(minutes, "minute");
	const hours = Math.round(minutes / 60);
	if (Math.abs(hours) < 24) return rtf.format(hours, "hour");
	return rtf.format(Math.round(hours / 24), "day");
}
const formatScore = (value, displayMaximum, notScored, locale) => formatScore$1(value, displayMaximum, notScored, locale);
const formatNumber = (n, locale, maximumFractionDigits = 0) => new Intl.NumberFormat(locale, { maximumFractionDigits }).format(n);
function formatBytes(bytes, locale) {
	const units = [
		"B",
		"KB",
		"MB",
		"GB",
		"TB"
	];
	let value = bytes;
	let unit = 0;
	while (value >= 1024 && unit < units.length - 1) {
		value /= 1024;
		unit += 1;
	}
	return `${formatNumber(value, locale, unit === 0 ? 0 : 1)} ${units[unit] ?? "B"}`;
}
export { formatBytes, formatDate, formatDateTime, formatNumber, formatRelative, formatScore };

//# sourceMappingURL=format.js.map